import { Buffer } from '@stacks/common';
import { utils } from '@noble/secp256k1';
export const randomBytes = (bytesLength) => Buffer.from(utils.randomBytes(bytesLength));
//# sourceMappingURL=cryptoRandom.js.map